<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss" >
* {
  padding: 0;
  margin: 0;
  list-style: none;
}
html {
  font-family: "Pingfang SC", "Microsoft YaHei", "微软雅黑", "黑体", Arial,
    sans-serif !important;
}
img {
  object-fit: cover;
}
input {
  outline: none;
}
button {
  cursor: pointer;
}
a {
  text-decoration: none;
}
:focus {
  outline: none !important;
  z-index: 10000;
}
input::-moz-focus-inner,
button::-moz-focus-inner {
  border: 0;
}
.el-input__inner:focus {
  border-color: #c70000 !important;
}
.el-button:focus {
  border-color: #c70000 !important;
}
.el-button:hover {
  border-color: #c70000 !important;
}
.el-select .el-input__inner:focus {
  border-color: #c70000 !important;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #c70000 !important;
}
.el-button:hover {
  color: #fff !important ;
  background-color: #c70000 !important  ;
}
.el-button--primary {
  background-color: #c70000 !important;
  border-color: #c70000 !important;
  color: #fff !important ;
}
.el-button--primary:focus {
  background-color: #c70000 !important;
  color: #fff !important ;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #c70000 !important;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color:#FFEAEA !important;
}
.el-range-editor.is-active, .el-range-editor.is-active:hover {
  border-color: #c70000 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue